import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, inject } from "@angular/core";
import { AuthCallbackBaseComponent } from "../../ffwd/components/auth-callback-base/auth-callback-base.component";
import { ApplicationService } from "src/app/services/application.service";

@Component({
  selector: "app-auth-callback",
  imports: [],
  templateUrl: "./auth-callback.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./auth-callback.component.less",
})
export class AuthCallbackComponent extends AuthCallbackBaseComponent implements OnInit, OnDestroy {
  private application = inject(ApplicationService);

  public constructor() {
    super();
    this.AUTH_SUCCESS_URL = "/content";
  }

  public ngOnInit(): Promise<void> {
    this.application.setLoading(true);
    return super.ngOnInit();
  }

  public ngOnDestroy(): void {
    this.application.setLoading(false);
  }
}
